import { render } from "./Election.vue?vue&type=template&id=8468a734&scoped=true&ts=true"
import script from "./Election.vue?vue&type=script&lang=ts"
export * from "./Election.vue?vue&type=script&lang=ts"

import "./Election.vue?vue&type=style&index=0&id=8468a734&scoped=true&lang=scss"

import exportComponent from "E:\\SLG\\ECO GAME\\Eco\\Server\\WebClient\\Sources\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8468a734"]])

export default __exports__